
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partido/[slug]/prediccion-de-partido",
      function () {
        return require("private-next-pages/partido/[slug]/prediccion-de-partido.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partido/[slug]/prediccion-de-partido"])
      });
    }
  